export default __webpack_public_path__ + "static/4-38878d67a69fb6843372500a1f1a8089.webp";